var m = require('mithril');
var key = require('../../../libs/keybindings');
var Model = require('../../../libs/Model');
var modal = require('../../../layout/components/modal');
var loaders = require('../../../layout/components/loaders');

var deletePartModal = Object.create(Model);


deletePartModal.editDialogue = function (recordRid, nodesAndLinksDeleted, options) {
  var submit = (unlink) => {
    const baseUrl = unlink
    ? `/api/v1/system`
    : `/api/v1/customequipment`;

    const url = `${baseUrl}/${recordRid.slice(1)}/deletediagram`;

    return loaders.requestWithLoader({
      loader: 'main',
      url,
      method: 'PUT',
      body: {nodesAndLinksDeleted: nodesAndLinksDeleted}
    })
    .then(function (result) {
      key.unbind('enter');
      modal.vm.close();
      m.redraw();
    });
  };
  var submitDelete = function () {
    return submit(false);
  };

  key.setScope('modal');
  key('enter', 'modal', submitDelete);

  modal.vm.title('Delete: ');
  modal.vm.body = deletePartModal.view;
  let buttons = [
    {
      label: "Cancel",
      class: "f4 ba bw1 ph3 pv2 tc v-btm dib mr2",
      func: function () {
        key.unbind('enter');
        modal.vm.close();
      }
    },
    {
      label: "Delete",
      class: "f4 ba bw1 ph3 pv2 tc v-btm dib mr2 red",
      func: submitDelete
    }
  ];

  if (options && options.isSystem) {
    buttons.splice(1, 0, {
      label: "Unlink",
      class: "f4 ba bw1 ph3 pv2 tc v-btm dib mr2 red",
      func: function () {
        return submit(true);
      }
    });
  }
 

  modal.vm.buttons(buttons);
  modal.vm.open();
  m.redraw();

  
  modal.once('closed', function () {
    options && options.submitCallback ? options.submitCallback() : '';
    key.deleteScope('modal');
    key.setScope('home');
  });
}


deletePartModal.view = function () {
  return m('form', {role:'form'}, [
    m('div', 'Are you sure you want to delete this part?')
  ])  
}

module.exports = deletePartModal;
